const setValue = (args, state, utils) => {
    if (!args || !args.length) return;
    const id = args[0];
    const value = args[1];
    if (id) {
        utils.changeValue(state, id, () => value);
    }
};

export {
    setValue
};
